import * as React from 'react';

export const useLambda = <T>(initialValue: T | (() => T), deps: React.DependencyList = []) => {
	const [value, setValue] = React.useState(initialValue);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const setValueLambda = React.useCallback((newValue: T) => () => setValue(newValue), deps);
	return [value, setValue, setValueLambda] as const;
};
